import * as React from "react";
import { menuBlock } from "./SupportTiles.module.scss";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

export const MenuBlock: React.FC<any> = (props) => {
  return <Col className={menuBlock}>{props.children}</Col>;
};

export const TileLink: React.FC<any> = (props) => {
  let section = "";
  let question = "";
  let linkType = "newpage";
  if (props.link.url.indexOf("#") != -1) {
    const url = props.link.url.replace("#", "");
    const urlSplit = url.split("//");
    section = urlSplit[0];
    question = urlSplit[1];
    linkType = "samepage";
  }
  const handleTileClick = () => {
    props.onClick(section, question);
  };

  return linkType == "newpage" ? (
    <a href={props.link.url}>{props.link.title}</a>
  ) : (
    <Button variant="link" onClick={handleTileClick}>
      {props.link.title}
    </Button>
  );
};
